
const observer = new IntersectionObserver( ( entries, observer ) => {
    for( let i = 0, length = entries.length; i !== length; ++i ) {
        const entry = entries[i], image = entry.target;
        if( entry.isIntersecting ) {
            image.src = image.dataset.src;
            observer.unobserve( image );
        }
    }
}, { rootMargin: '50px 0px' } );

export default
{
    inserted( node )
    {
        //console.log( 'bind', arguments );
        if( 'IntersectionObserver' in window ) {
            observer.observe(node);
        } else node.target.src = node.target.dataset.src;
    },
    update()
    {
        //console.log( 'update', arguments );
    },
    unbind( node )
    {
        //console.log( 'unbind', arguments );
        observer.unobserve( node );
    }
};
